import { Box, Card, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

// AccountCard is the frame of the pages reached before login. It's centred on a
// desktop window and fills the width of a phone.
export function AccountCard(props: PropsWithChildren<{ title: string }>) {
    return (
        <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: { xs: "center", sm: "flex-start" },
            flex: 1,
            overflow: "auto",
            p: 2,
            pt: { xs: 2, sm: 10 },
        }}>
            <Card sx={{ width: "100%", maxWidth: 360, p: { xs: 3, sm: 4 } }}>
                <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
                    <img src="/favicon.svg" alt="" width={48} height={48} />
                </Box>
                <Typography variant="h6" align="center">{props.title}</Typography>
                <div style={{ height: 16 }} />
                {props.children}
            </Card>
        </Box>
    );
}

// emailInputProps gives the email keyboard without the browser's validation
export const emailInputProps = {
    htmlInput: { inputMode: "email" as const, autoCapitalize: "none", autoCorrect: "off" },
};
